import type { I18nFn } from '#/i18n/types/I18nFn';

export function cmsGetDonateBlockSubmitButtonText(
  i18n: I18nFn,
  amount?: string,
) {
  if (amount) {
    return i18n('Donate $%(amount)s USD', {
      amount: amount.toString(),
    });
  }
  return i18n('Donate');
}
